/**
 * @generated SignedSource<<51bae9a32760cc1fc3a308e4e1d8d889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberSelectAllEntitiesFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MemberSelectEntityFragment">;
    };
  }>;
  readonly " $fragmentType": "MemberSelectAllEntitiesFragment";
};
export type MemberSelectAllEntitiesFragment$key = {
  readonly " $data"?: MemberSelectAllEntitiesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberSelectAllEntitiesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberSelectAllEntitiesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MemberSelectEntityFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EntityConnection",
  "abstractKey": null
};

(node as any).hash = "ce6efd85a1a250527c684f2ecdb83047";

export default node;
